import React from "react";
import {FormattedMessage} from "react-intl";
import classes from "./styles.module.css";

const Empty = () => {
    return (
        <tr className={classes.EmptyRow}>
            <td colSpan="6">
                <div className={classes.Empty}>
                    <h5>
                        <FormattedMessage id="PcaTable.empty" defaultMessage="Нет ПСА"/>
                    </h5>
                </div>
            </td>
        </tr>
    );
};

export default Empty;



// WEBPACK FOOTER //
// ./src/Components/PcaTable/Empty.js